import script from "./HeaderNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNavigation.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNavigation.vue?vue&type=style&index=0&id=5a10d47a&scope=true&lang=css"

const __exports__ = script;

export default __exports__